import { Component, Input } from '@angular/core';

export class TagItem {
    constructor(public label: string, public value: string, public type: TagType) { }
}

type TagType = 'danger' | 'warning' | 'info' | 'success' | 'default';

@Component({
    selector: 'psm-tag',
    templateUrl: 'tag.component.html'
})
export class TagComponent {
    @Input() public item: TagItem;
}



// WEBPACK FOOTER //
// ./src/app/components/common/tag/tag.component.ts